// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from 'D:/CloudPatrolUI/Mayun.UI/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'D:/CloudPatrolUI/Mayun.UI/src/layouts/BlankLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Login' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Login'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__SecurityLayout' */'D:/CloudPatrolUI/Mayun.UI/src/layouts/SecurityLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'D:/CloudPatrolUI/Mayun.UI/src/layouts/BasicLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/",
                "redirect": "/dashboard",
                "exact": true
              },
              {
                "path": "/dashboard",
                "name": "dashboard",
                "icon": "dashboard",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dashboard' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Dashboard'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/bi",
                "name": "bi",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BI' */'D:/CloudPatrolUI/Mayun.UI/src/pages/BI'), loading: LoadingComponent}),
                "authority": "666666",
                "exact": true
              },
              {
                "path": "/basic",
                "name": "basic",
                "icon": "database",
                "routes": [
                  {
                    "path": "/basic/history",
                    "name": "history",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__History' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Basic/History'), loading: LoadingComponent}),
                    "authority": "20204",
                    "exact": true
                  },
                  {
                    "path": "/basic/report",
                    "name": "report",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Report' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Basic/Report'), loading: LoadingComponent}),
                    "authority": "20304",
                    "exact": true
                  },
                  {
                    "path": "/basic/detail",
                    "name": "detail",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Detail' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Basic/Detail'), loading: LoadingComponent}),
                    "authority": "20304",
                    "exact": true
                  },
                  {
                    "path": "/basic/chart",
                    "name": "chart",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Chart' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Basic/Chart'), loading: LoadingComponent}),
                    "authority": "20404",
                    "exact": true
                  },
                  {
                    "path": "/basic/omit",
                    "name": "omit",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Omit' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Basic/Omit'), loading: LoadingComponent}),
                    "authority": "20504",
                    "exact": true
                  },
                  {
                    "path": "/basic/alarm",
                    "name": "alarm",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Alarm' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Basic/Alarm'), loading: LoadingComponent}),
                    "authority": "20604",
                    "exact": true
                  },
                  {
                    "path": "/basic/calendar",
                    "name": "calendar",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Calendar' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Basic/Calendar'), loading: LoadingComponent}),
                    "authority": "21304",
                    "exact": true
                  },
                  {
                    "path": "/basic/raw",
                    "name": "raw",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Raw' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Basic/Raw'), loading: LoadingComponent}),
                    "authority": "21204",
                    "exact": true
                  },
                  {
                    "path": "/basic/realmap",
                    "name": "realmap",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RealTimeMap' */'D:/CloudPatrolUI/Mayun.UI/src/pages/RealTimeMap'), loading: LoadingComponent}),
                    "authority": "21104",
                    "exact": true
                  },
                  {
                    "path": "/basic/log",
                    "name": "log",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Log' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Basic/Log'), loading: LoadingComponent}),
                    "authority": "20704",
                    "exact": true
                  },
                  {
                    "path": "/basic/attendance",
                    "name": "attendance",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Attendance' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Basic/Attendance'), loading: LoadingComponent}),
                    "authority": "21404",
                    "exact": true
                  },
                  {
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__404' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Exception/404'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/setup",
                "name": "setup",
                "icon": "control",
                "routes": [
                  {
                    "path": "/setup/dept",
                    "name": "dept",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Dept' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Dept'), loading: LoadingComponent}),
                    "authority": "10104",
                    "exact": true
                  },
                  {
                    "path": "/setup/event",
                    "name": "event",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Event' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Event'), loading: LoadingComponent}),
                    "authority": "10204",
                    "exact": true
                  },
                  {
                    "path": "/setup/guard",
                    "name": "guard",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Guard' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Guard'), loading: LoadingComponent}),
                    "authority": "10304",
                    "exact": true
                  },
                  {
                    "path": "/setup/site",
                    "name": "site",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Site' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Site'), loading: LoadingComponent}),
                    "authority": "10404",
                    "exact": true
                  },
                  {
                    "path": "/setup/content",
                    "name": "content",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Content' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Content'), loading: LoadingComponent}),
                    "authority": "11004",
                    "exact": true
                  },
                  {
                    "path": "/setup/plan",
                    "name": "plan",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Plan' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Plan'), loading: LoadingComponent}),
                    "authority": "10504",
                    "exact": true
                  },
                  {
                    "path": "/setup/voice",
                    "name": "voice",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Voice' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Voice'), loading: LoadingComponent}),
                    "authority": "11204",
                    "exact": true
                  },
                  {
                    "path": "/setup/book",
                    "name": "book",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Book' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Book'), loading: LoadingComponent}),
                    "authority": "10704",
                    "exact": true
                  },
                  {
                    "path": "/setup/receipt",
                    "name": "receipt",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Receipt' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Receipt'), loading: LoadingComponent}),
                    "authority": "10804",
                    "exact": true
                  },
                  {
                    "path": "/setup/downparam",
                    "name": "downparam",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__DownParam' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/DownParam'), loading: LoadingComponent}),
                    "authority": "10904",
                    "exact": true
                  },
                  {
                    "path": "/setup/talk",
                    "name": "talk",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Talk' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Talk'), loading: LoadingComponent}),
                    "authority": "11104",
                    "exact": true
                  },
                  {
                    "path": "/setup/duty",
                    "name": "duty",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Setup__Duty' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Setup/Duty'), loading: LoadingComponent}),
                    "authority": "11304",
                    "exact": true
                  },
                  {
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__404' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Exception/404'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/data",
                "name": "data",
                "icon": "bulb",
                "routes": [
                  {
                    "path": "/data/device",
                    "name": "device",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Data__Device' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Data/Device'), loading: LoadingComponent}),
                    "authority": "30204",
                    "exact": true
                  },
                  {
                    "path": "/data/system",
                    "name": "system",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Data__System' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Data/System'), loading: LoadingComponent}),
                    "authority": "30304",
                    "exact": true
                  },
                  {
                    "path": "/data/user",
                    "name": "user",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Data__User' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Data/User'), loading: LoadingComponent}),
                    "authority": "30704",
                    "exact": true
                  },
                  {
                    "path": "/data/role",
                    "name": "role",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Data__Role' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Data/Role'), loading: LoadingComponent}),
                    "authority": "30604",
                    "exact": true
                  },
                  {
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__404' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Exception/404'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/company",
                "name": "company",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Company' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Company'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/exception",
                "hideInMenu": true,
                "routes": [
                  {
                    "path": "/exception/403",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__403' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Exception/403'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/exception/404",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__404' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Exception/404'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "path": "/exception/500",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__500' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Exception/500'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__404' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Exception/404'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__404' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Exception/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__404' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Exception/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      }
    ]
  },
  {
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Exception__404' */'D:/CloudPatrolUI/Mayun.UI/src/pages/Exception/404'), loading: LoadingComponent}),
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
